module.exports = __webpack_public_path__ + "src/assets/img/index_guest.8cd18392.jpg";